export const ABHA_PATIENT_MYPROFILE = `/abha/v1/patients/abha-accounts/`;
export const ABHA_SEND_OTP = "abha/v1/patients/profile/login/request/otp";
export const ABHA_VERIFY_OTP = "abha/v1/patients/profile/login/verify";
export const ABHA_DOWNLOAD_CARD = (details) =>
  `abha/v1/patients/profile/account/abha-card/${details.txnid}`;
